import React, { useState, useEffect } from "react";
import { Table, Spinner, Button, Input, Badge } from "reactstrap";
import { FaFilter, FaSyncAlt, FaStar } from "react-icons/fa";
import { useSelector } from "react-redux";
import axios from "axios";

const PartnerPerformance = () => {
  const [search, setSearch] = useState("");
  const [partnerFilter, setPartnerFilter] = useState("all");
  const [categoryFilter, setCategoryFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [partners, setPartners] = useState([]);
  
  const { AuthReducer: { auth } } = useSelector((state) => state);

  useEffect(() => {
    fetchPartnerPerformance();
  }, [search, partnerFilter, categoryFilter]);

  const fetchPartnerPerformance = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/api/admin/v1/partner-performance", {
        headers: { Authorization: `Bearer ${auth?.token}` },
        params: {
          search,
          status: partnerFilter !== 'all' ? partnerFilter : undefined,
          category: categoryFilter !== 'all' ? categoryFilter : undefined
        }
      });
      setPartners(response.data.partners || []);
    } catch (error) {
      console.error('Failed to fetch partner performance:', error);
    } finally {
      setLoading(false);
    }
  };

  const clearFilters = () => {
    setSearch("");
    setPartnerFilter("all");
    setCategoryFilter("all");
  };

  const getCategoryBadge = (category) => {
    const colors = {
      "Tour Operator": "danger",
      "Business": "primary",
      "Organization": "info"
    };
    return <Badge color={colors[category] || "secondary"}>{category}</Badge>;
  };

  const renderStars = (rating) => {
    return (
      <span className="text-warning">
        {[...Array(5)].map((_, i) => (
          <FaStar key={i} className={i < Math.floor(rating) ? "" : "text-muted"} />
        ))}
        <span className="text-muted ms-1">{rating}</span>
      </span>
    );
  };

  return (
    <div>
      <div className="row my-3">
        <div className="col-md-12">
          <div className="mb-4 d-flex align-items-center justify-content-between">
            <h5 className="mb-0 text-white fs-4">
              Partner Performance
            </h5>
          </div>
        </div>
      </div>

      <div
        className="bg-white px-3 py-4 rounded-2 my-4"
        style={{ boxShadow: "4px 4px 18px rgba(0,0,0,0.15)" }}
      >
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div className="flex-grow-1" style={{ maxWidth: "190px" }}>
            <Input
              type="text"
              className="form-control"
              placeholder="🔍 Search partners..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <div className="d-flex flex-wrap gap-2">
            <Input
              type="select"
              value={partnerFilter}
              onChange={(e) => setPartnerFilter(e.target.value)}
              style={{ width: "140px" }}
            >
              <option value="all">All Partners</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Input>
            <Input
              type="select"
              value={categoryFilter}
              onChange={(e) => setCategoryFilter(e.target.value)}
              style={{ width: "140px" }}
            >
              <option value="all">All Categories</option>
              <option value="business">Business</option>
              <option value="organization">Organization</option>
              <option value="tour">Tour Operator</option>
            </Input>
            <button
              className="btn btn-outline-danger"
              onClick={clearFilters}
            >
              <FaFilter className="me-1" />
              Clear Filters
            </button>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12">
            <Table hover responsive>
              <thead>
                <tr>
                  <th>SL. No.</th>
                  <th>Partner Name</th>
                  <th>Partner ID</th>
                  <th>Category</th>
                  <th>Ratings</th>
                  <th>Online Sales</th>
                  <th>Online Revenue</th>
                  <th>Counter Sales</th>
                  <th>Counter Revenue</th>
                  <th>Total Sales</th>
                  <th>Total Revenue</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="11" className="text-center">
                      <Spinner />
                    </td>
                  </tr>
                ) : partners.length === 0 ? (
                  <tr>
                    <td colSpan="11" className="text-center">No partners found</td>
                  </tr>
                ) : (
                  partners.map((partner, index) => {
                    const totalSales = partner.onlineSales + partner.counterSales;
                    const totalRevenue = partner.onlineRevenue + partner.counterRevenue;
                    
                    return (
                      <tr key={index}>
                        <th scope="row">{index + 1}</th>
                        <td className="fw-semibold">{partner.businessName || partner.name}</td>
                        <td>{partner.partnerId || partner.id}</td>
                        <td>{getCategoryBadge(partner.category || partner.type)}</td>
                        <td>{renderStars(partner.avgRating || partner.rating || 0)}</td>
                        <td>{partner.onlineSales || 0}</td>
                        <td>₹{(partner.onlineRevenue || 0).toLocaleString()}</td>
                        <td>{partner.counterSales || 0}</td>
                        <td>₹{(partner.counterRevenue || 0).toLocaleString()}</td>
                        <td className="fw-semibold text-primary">{totalSales}</td>
                        <td className="fw-semibold text-primary">₹{totalRevenue.toLocaleString()}</td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PartnerPerformance;        